import {AppSettings} from "../settings";

/**
 * Constructs a URL for the /get/ endpoint on the scores server.
 *
 * @param dataType - The API endpoint to fetch data from.
 * @return The full URL pointing to the /get/ endpoint on the scores server.
 */
export function apiGetUrl(dataType: string): string {
  return `${AppSettings.SCORES_SERVER}/get/${dataType}/`;
}